<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
/**
 * @see https://github.com/bvaughn/react-virtualized/blob/master/source/CellMeasurer/CellMeasurer.js
 */
export default {
  name: 'CellMeasurer',
  props: {
    heights: { type: Array },
    index: { type: Number },
  },
  mounted() {
    this._maybeMeasureCell()
  },
  updated() {
    this._maybeMeasureCell()
  },
  methods: {
    _getCellMeasurements() {
      const node = this.$el
      if (
        node &&
        node.ownerDocument &&
        node.ownerDocument.defaultView &&
        node instanceof node.ownerDocument.defaultView.HTMLElement
      ) {
        const styleWidth = node.style.width
        const styleHeight = node.style.height

        const height = Math.ceil(node.offsetHeight)
        const width = Math.ceil(node.offsetWidth)

        // Reset after measuring to avoid breaking styles see #660
        if (styleWidth) {
          node.style.width = styleWidth
        }
        if (styleHeight) {
          node.style.height = styleHeight
        }

        return { height, width }
      }
      return { height: 0, width: 0 }
    },
    _maybeMeasureCell() {
      const { heights, index } = this
      if (!heights[index]) {
        const { height } = this._getCellMeasurements()
        this.$set(heights, index, height)
      }
    },
  },
}
</script>
